import { useState } from "react";
import { useQuote } from "@/context/QuoteContext";
import { useLang } from "@/i18n/LanguageContext";
import { Plane, ArrowRight, X } from "lucide-react";

export default function AnnouncementBar() {
  const { openQuote } = useQuote();
  const { t } = useLang();
  const [open, setOpen] = useState(() => !sessionStorage.getItem("mgd_announce_dismissed"));
  if (!open) return null;

  const dismiss = (e) => { e.stopPropagation(); sessionStorage.setItem("mgd_announce_dismissed", "1"); setOpen(false); };

  return (
    <div
      className="cursor-pointer"
      style={{ backgroundColor: "#C6A038", color: "#2A1526" }}
      onClick={() => openQuote({ type: "call" })}
      role="button"
      data-testid="announcement-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-center gap-2 text-center relative">
        <Plane className="w-4 h-4 shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm font-medium">
          <b>{t("announce.bold")}</b> {t("announce.rest")}
          <span className="inline-flex items-center gap-1 underline underline-offset-2 ml-1 font-semibold">{t("announce.cta")} <ArrowRight className="w-3.5 h-3.5" /></span>
        </p>
        <button onClick={dismiss} aria-label="Dismiss" className="absolute right-3 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100" data-testid="announcement-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
